/**
 * Stable admin action codes emitted by the backend (011 contract §5).
 * Must be kept in sync with `SadeceBilgisayar.DATA.Models.AdminActionLog.AdminActionType`.
 */
export type AdminActionType =
  | 'ListingApproved'
  | 'ListingRejected'
  | 'UserBanned'
  | 'UserUnbanned'
  | 'SupportTicketStarted'
  | 'SupportTicketResolved';

export const ADMIN_ACTION_TYPES: readonly AdminActionType[] = [
  'ListingApproved',
  'ListingRejected',
  'UserBanned',
  'UserUnbanned',
  'SupportTicketStarted',
  'SupportTicketResolved',
] as const;
